import { Api } from '../AApi'

export const API_DATASTORE = new Api(
  {
    url: 'datastores',
    isConvertFormData: true,
  },
  {
    publish: {
      request(datastore_id, id, data) {
        return this.sdk.post(`${this.url}/${datastore_id}/${id}/publish`, data)
      },
      type: 'create',
    },
    sync: {
      request(id) {
        return this.sdk.request({
          url: `datastores/${id}/sync`,
        })
      },
      type: 'update',
    },
    sysApi: {
      async request(data) {
        return this.sdk
          .request({
            method: 'put',
            url: `sysapi`,
            data,
          })
          .then((res) => res.data)
      },
      type: 'update',
    },
  }
)

export const API_FIELD = new Api({ url: `datastore-details/{id}/fields` }, {
  createOrder: {
    async request(data) {
      const res = await this.sdk.put(`datastore-fields-order`, data)
      return res.data
    },
    type: 'update',
  },
  store: {
    async request(data) {
      const res = await this.sdk.post(this.url, data)
      return res.data
    },
    type: 'create',
  },
})

export const API_FEATURE = new Api(
  { url: `datastore-details/{id}/features` },
  {
    update: {
      async request(id, data) {
        const res = await this.sdk.put(`${this.url}/fields/${id}`, data)
        return res.data
      },
      type: 'update',
    },
    delete: {
      async request(id) {
        const res = await this.sdk.delete(`${this.url}/fields/${id}`)
        return res.data
      },
      type: 'destroy',
    },
  }
)
